// extracted by mini-css-extract-plugin
export default {"weekdayHeadersContainer":"weekdayHeaders_weekdayHeadersContainer","weekdayLabel":"weekdayHeaders_weekdayLabel"};